import { render, staticRenderFns } from "./ChartWarningForIE.vue?vue&type=template&id=09c80891&"
import script from "./ChartWarningForIE.vue?vue&type=script&lang=js&"
export * from "./ChartWarningForIE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports